module.exports = __webpack_public_path__ + "static/media/ic_link.0c567c35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_link.svg
// module id = 305
// module chunks = 0